module.exports = __webpack_public_path__ + "img/ee9a7ae.jpg";